import React from "react";
import {graphql, Link, useStaticQuery} from "gatsby";
import shape from "../../assets/images/shape/vector-shape6.png";
import project6 from '../../assets/images/projects/project6.jpg'


const query = graphql`
{
  allStrapiNewsletters {
    nodes {
      id
      title
      description
    }
  }
}
`

const Newsletters = () => {
    const data = useStaticQuery(query)
    const {
        allStrapiNewsletters: { nodes: newsletters },
    } = data
    return (
        <div className="courses-area ptb-100 bg-fafafb">
            <div className="container">
                <div className="row">
                    {
                        newsletters.map((newsletter, idx) => {
                            return (
                                <div className="col-lg-4 col-md-6" key={idx}>
                                    <div className="single-courses-box ">
                                        <div className="courses-image">
                                            <Link to={`/newsletters/${newsletter.id}`} className="d-block image">
                                                <img src={project6} alt="about" />
                                            </Link>
                                            <Link to="#" className="fav">
                                                <i className="flaticon-heart"></i>
                                            </Link>
                                        </div>
                                        <div className="courses-content">
                                            <h3>
                                                <Link to={`/newsletters/${newsletter.id}`}>
                                                    {newsletter.title}
                                                </Link>
                                            </h3>
                                            <p>{newsletter.description}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }

                    {/* Pagination */}
                    <div className="col-lg-12 col-md-12">
                        <div className="pagination-area text-center">
                            <Link to="#" className="prev page-numbers">
                                <i className='bx bx-chevrons-left'></i>
                            </Link>
                            <span className="page-numbers current">1</span>
                            <Link to="#" className="page-numbers">
                                2
                            </Link>
                            <Link to="#" className="page-numbers">
                                3
                            </Link>
                            <Link to="#" className="page-numbers">
                                4
                            </Link>
                            <Link to="#" className="next page-numbers">
                                <i className='bx bx-chevrons-right'></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="vector-shape6">
                <img src={shape} alt="about" />
            </div>
        </div>
    )
}

export default Newsletters
